import { statuses } from '@/returns/constants'

export const transactionalStatuses = [statuses.inProgress, statuses.shipped, statuses.received, statuses.forReview]
